<button class="si-radio-button {{styleClass}} siProvideParentForm"
        [class.disabled]="disabled"
        [class.si-radio-button_selected]="model === value"
        [disabled]="disabled"
        type="button"
        (click)="onClickButton()">
  <span>{{text | translate}}</span>
</button>
